import Drawer from "../drawer/Drawer";
import React, {useEffect, useState} from "react";
import {CustomInput} from "../kits/inputs/Input";
import ColorSchema from "../../assets/kits/colors";
import {Col, Container, Row} from "react-bootstrap";
import defaultImage from "../../assets/images/defaultCover/defaultCoverProduct.png";
import CustomButton from "../kits/custom-button/CustomButton";
import "./SearchProductDrawer.scss";


/*

    Example:

        const [isOpen, setIsOpen] = useState(true); // state for open and close

        <SearchProductDrawer open={isOpen} setIsOpen={setIsOpen}/> // Componnent


 */

const SearchProductDrawer = ({open,setIsOpen}) => {

    const [searchText, setSearchText] = useState("");

    useEffect(() => {setSearchText("")} ,[open]);

    const products = [
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
        {title: "نام محصول اینجاست", image: ""},
    ]

    const onChangeSearch = ({value}) => {
        setSearchText(value)
    }

    return (
        <>
            <Drawer
                isOpen={open} onClose={() => setIsOpen(false)} height={560} className="d-flex">
                <div className="d-flex flex-column pd-x-16 pd-t-16 search-drawer" style={{height: "98%"}}>
                    <span className="title-h3-b"
                          style={{color: ColorSchema.foreground_background_he}}>جستجو در محصول ها</span>

                    <div className="container mr-t-16">
                        <Row>
                            <Col className="p-0">
                                <CustomInput
                                    placeholder="جستجو در محصول‌های سبدی"
                                    className="title"
                                    value={searchText}
                                    onChange={({target}) => {
                                        onChangeSearch(target);
                                    }}
                                    haveIcon={true}/>
                            </Col>

                            {(searchText != "") && (
                                <Col xs={"auto"} className="d-flex p-0  mr-r-16">
                                    <span
                                        className="txt-t1-m my-auto pd-x-12"
                                        onClick={() => setSearchText("")}
                                        style={{cursor: "pointer"}}>انصراف</span>
                                </Col>
                            )}
                        </Row>
                    </div>

                    <div className="text-center mt-auto flex-grow-1 overflow-auto ">

                        {(searchText == "") && (
                            <div className="h-100 d-flex justify-content-center flex-column ">
                              <span className="title-h4-b"
                                    style={{lineHeight: "24px", color: ColorSchema.foreground_background_he}}>محصولی که می خواهید اضافه کنید<br/> را جستوجو کنید</span>
                            </div>
                        )}

                        {((searchText != "") && (products.length == 0)) && (
                            <div className="h-100 d-flex justify-content-center flex-column text-center empty-box mx-auto">
                              <span className="title-h4-b"
                                    style={{lineHeight: "24px", color: ColorSchema.foreground_background_he}}>این محصول در سبدی موجود نیست</span>
                                <span className="txt-t2-r"
                                      style={{lineHeight: "24px", color: ColorSchema.foreground_background_he}}>برای اضافه شدن این محصول روی دکمه زیر بزنید تا پشتیبان سبدی پیگیری لازم را انجام دهد</span>

                                <CustomButton
                                    buttonStyle="secondary"
                                    className="pd-y-12 mr-t-12"
                                    size="medium"
                                >
                                    درخواست افزودن محصول
                                </CustomButton>
                            </div>
                        )}

                        {((searchText != "") && (products.length != 0)) && (
                            <div className="pd-y-16 " style={{cursor: "pointer"}}>
                                {products.map((product, index) => (
                                    <>
                                        {(index != 0) && (
                                            <hr className="line mr-y-12"/>
                                        )}
                                        <div className="d-flex flex-row">
                                            <img
                                                src={defaultImage}
                                                style={{width: "40px", height: "40px", borderRadius: "6px"}}/>
                                            <span className="txt-t2-m mr-r-12 my-auto"
                                                  style={{color: ColorSchema.foreground_background_he}}>{product.title}</span>
                                        </div>
                                    </>
                                ))}
                            </div>
                        )}
                    </div>

                </div>


            </Drawer>

        </>
    );
};


export default SearchProductDrawer;